import React, { forwardRef } from "react";
import { CancelButton, CenterPopup, CancelAndSaveButtons, CenterPopupContent, CrossButton } from "./GlobalPopupContainerStyle";
import ContinueBtn from "../btn/continueBtn/continueBtn";
import AnimationWrapperForPopup from "../animationWrapper/AnimationWrapperForPopup";
import useHandleGlobalPopupSwipe from "../../hook/useHandleGlobalPopupSwipe";
import useIsDesktopSize from "../../hook/useIsDesktopSize";

interface PopupContainerProps {
    children: React.ReactNode;
    closePopup: () => void;
    style?: React.CSSProperties;
    handleSave?: () => void;
    disable?: boolean;
    isContinueBtnLoading?: boolean;
    btnText?: string;
    btnColor?: string;
    backBtnType?: "Arrow" | "Close";
    noBackBtn?: boolean;
    noContinueBtn?: boolean;
    desktopWidth?: string;
    height?: string;
    desktopHeight?: string;
    backBtnBackground?: boolean;
    cancelBtnText?: string;
    cancelPopup?: () => void;
    noBackdrop?: boolean;
    noCancelBtn?: boolean;
    shadow?: boolean;
    backgroundColor?: string;
}

const GlobalPopupContainerCenter = forwardRef<HTMLDivElement, PopupContainerProps>(
    (
        {
            children,
            closePopup,
            style,
            handleSave,
            disable,
            isContinueBtnLoading,
            btnText,
            btnColor,
            backBtnType,
            noBackBtn,
            noContinueBtn,
            desktopWidth,
            height,
            desktopHeight,
            backBtnBackground,
            cancelBtnText,
            cancelPopup,
            noBackdrop,
            noCancelBtn,
            shadow,
            backgroundColor,
        },
        ref
    ) => {
        const isDesktopSize = useIsDesktopSize();
        const { popupRef, dragY, handleTouchStart, handleTouchMove, handleTouchEnd } = useHandleGlobalPopupSwipe(closePopup);

        return (
            <>
                <AnimationWrapperForPopup noBackdrop={noBackdrop} onClose={closePopup}>
                    <CenterPopup 
                        ref={(node) => {
                            // Handle both refs
                            if (typeof ref === 'function') {
                                ref(node);
                            } else if (ref) {
                                ref.current = node;
                            }
                            popupRef.current = node;
                        }}
                        style={{
                            ...style,
                            transform: !isDesktopSize ? `translateY(${dragY}px)` : undefined,
                            transition: dragY === 0 ? 'transform 0.3s ease-out' : 'none'
                        }}
                        desktopWidth={desktopWidth}
                        height={height}
                        desktopHeight={desktopHeight}
                        backgroundColor={backgroundColor}
                    >
                        {!noBackBtn && (
                            <CrossButton
                                onClick={() => closePopup()}
                                onTouchEnd={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    closePopup();
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '24px',
                                    left: '24px',
                                    zIndex: 1000
                                }}
                            >
                                <img 
                                                                    src={backBtnType === "Arrow" 
                                    ? "https://d292awxalydr86.cloudfront.net/Universal+icons/Back.svg"
                                    : "https://d292awxalydr86.cloudfront.net/Universal+icons/Cross.svg"
                                } 
                                    alt={backBtnType === "Arrow" ? "Back" : "Close"}
                                    width={16}
                                    height={16}
                                />
                            </CrossButton>
                        )}
                        <CenterPopupContent
                            onTouchStart={!isDesktopSize ? handleTouchStart : undefined}
                            onTouchMove={!isDesktopSize ? handleTouchMove : undefined}
                            onTouchEnd={!isDesktopSize ? handleTouchEnd : undefined}
                        >
                            {children}
                        </CenterPopupContent>
                        {!noContinueBtn && (
                            <CancelAndSaveButtons shadow={shadow}>
                                {!noCancelBtn && (
                                    <CancelButton
                                        disabled={isContinueBtnLoading}
                                        onTouchEnd={(event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            cancelPopup !== undefined ? cancelPopup() : closePopup();
                                        }}
                                        onClick={() => {
                                            cancelPopup !== undefined ? cancelPopup() : closePopup();
                                        }}
                                    >
                                        {cancelBtnText ? cancelBtnText : "Cancel"}
                                    </CancelButton>
                                )}
                                <ContinueBtn
                                    background={btnColor ? btnColor : "black"}
                                    style={{ width: noCancelBtn ? "100%" : "unset", margin: "0" }}
                                    onClick={handleSave}
                                    disabled={disable ? disable : false}
                                    isLoading={isContinueBtnLoading ? isContinueBtnLoading : false}
                                >
                                    {btnText ? btnText : "Save"}
                                </ContinueBtn>
                            </CancelAndSaveButtons>
                        )}
                    </CenterPopup>
                </AnimationWrapperForPopup>
            </>
        );
    }
);

export default GlobalPopupContainerCenter;
